export const categoryNameFromUrl = (url?: string | null): string => {
  if (!url) return '';

  // Remove all leading and trailing slashes
  const cleanUrl = url.replace(/^\/+|\/+$/g, '');
  if (!cleanUrl) return '';

  const segments = cleanUrl.split('/').filter(Boolean);
  // If only one segment and original url ends with a slash, treat as empty
  if (segments.length === 1 && /\/$/.test(url)) return '';

  const lastSegment = segments[segments.length - 1] || '';
  if (!lastSegment) return '';

  // Replace hyphens with spaces
  let formattedName = lastSegment.replace(/-/g, ' ');

  // Capitalize all words (convert to lowercase first, then capitalize first letter of each word)
  formattedName = formattedName
    .toLowerCase()
    .replace(/\b\w/g, char => char.toUpperCase());

  return formattedName;
};
